<template>
    <v-dialog
    v-model="localDialog"
    width="50%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? "Add Fixed Percentage Commission" : "Update Fixed Percentage Commission" }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="FixedPercentageCommissionSetup">
                    <v-row>
                        <v-col lg="6" md="6" cols="12">
                            <v-autocomplete
                            v-model="period_type.value.value"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :items = "period_types"
                            :item-title="(item)=> item.text"                                                  
                            item-value="value"
                            clearable        
                            autocomplete="off"
                            :error-messages="period_type.errorMessage.value"
                            >
                                <template #label>
                                    Period Type <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete>  

                            <v-number-input
                            v-model="percentage.value.value"
                            label="Percentage"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            class="ma-0"
                            control-variant="hidden"
                            :error-messages="percentage.errorMessage.value"
                            clearable>
                                <template #label>
                                    Percentage <span class="text-red-accent-4">*</span>
                                </template>
                            </v-number-input>

                            <v-checkbox
                            label="Active"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            single-line
                            color="primary"
                            value="1"
                            false-value="0"
                            ></v-checkbox>
                        </v-col>

                        <v-col lg="6" md="6" cols="12">
                            
                            <v-date-input
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="from_date.value.value"
                            :error-messages="from_date.errorMessage.value"
                            autocomplete="off"
                            clearable
                            >
                                <template #label>
                                    From Date
                                    <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>

                            <v-date-input
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="to_date.value.value"
                            :error-messages="to_date.errorMessage.value"
                            autocomplete="off"
                            clearable
                            >
                                <template #label>
                                To Date
                                <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>
                            
                            <v-textarea
                            label="Remarks (Optional)"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="remarks.value.value"
                            :error-messages="remarks.errorMessage.value"
                            clearable
                            auto-grow
                            rows="1"
                            ></v-textarea>
                        </v-col>

                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog">
                            Close
                            </v-btn>

                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
    name: "fixedPercentageCommissionSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                period_type: null,
                from_date: null,
                to_date: null,
                percentage: null,
                remarks: null,
                status: "1",
                commission_id: null,
            }),
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            selectedImage: null,
            errorMessages: "",
            preview: "/src/assets/no_preview.jpeg",
            loading: false,
            isEntryMode: true,

            period_types: [
                { text: "Monthly", value: "monthly" },
                { text: "Quarterly", value: "quarterly" },
                { text: "Annually", value: "annually" },
            ]
        };
    },
    computed: {},
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.period_type.setValue(newData.period_type || null, false);
                this.from_date.setValue(newData.from_date || null, false);
                this.to_date.setValue(newData.to_date || null, false);
                this.percentage.setValue(newData.percentage ? Number(newData.percentage) : null, 
                false);
                this.remarks.setValue(newData.remarks || null, false);
                this.status.setValue(String(newData.status) || "0", false);
                this.commission_id.setValue(newData.id || null, false);
            },
        },
    },
    created() {},
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                period_type: yup.string().min(1).max(50).required().trim().label("Period Type"),
                from_date: yup.date().required().label("From Date"),
                to_date: yup.date().required().label("To Date"),
                percentage: yup.number().min(1).max(100).required().label("Percentage"),
                remarks: yup.string().max(250).nullable().trim().label("Remarks"),
            }),
        });

        const commission_id = useField("commission_id");
        const period_type = useField("period_type");
        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const percentage = useField("percentage");
        const status = useField("status");
        const remarks = useField("remarks");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
            values.from_date = formattedDate(from_date.value.value);
            values.to_date = formattedDate(to_date.value.value);

            if(values.from_date > values.to_date) {
                toast.error("The to date field must be a date after or equal to from date.")
                return
            }

            store
                .dispatch("saveUpdateFixedPercentageCommission", values)
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    toast.success(response.data.message);
                    loading.value = true;
                    store
                        .dispatch("getSalesFixedPercentageCommissionList")
                        .then((data) => {
                            loading.value = false;
                        })
                        .catch((error) => {
                            loading.value = false;
                            toast.error(error.response.data.message);
                        });
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });
        return {
            submit,
            period_type,
            from_date,
            to_date,
            percentage,
            status,
            remarks,
            errorMessages,
            commission_id,
            resetForm,
            loading,
        };
    },
    mounted() {},
};
</script>
f